var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accordionItem",
      class: _vm.classes,
      attrs: { id: _vm.elementId },
    },
    [
      _c(
        "div",
        {
          staticClass: "accordionItem__container accordion__container",
          class: Object.assign(
            {},
            _vm.api.legacyContainerClasses(),
            // @deprecated you should use 'accordionItem--open' on the container instead!
            { "accordion__container--open": _vm.isOpen }
          ),
        },
        [
          _c(
            "dt",
            {
              staticClass: "accordionItem__labelWrap",
              class: {
                // @deprecated accordion__label--active will be removed together with accordion__label--open
                // you should use 'accordionItem--open' on the container instead!
                "accordion__label--active": _vm.isOpen,
                "accordion__label--open": _vm.isOpen,
              },
              on: { click: _vm.onToggleClick },
            },
            [
              _vm._t("labelWrap", function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "accordionItem__label accordion__label",
                      attrs: {
                        tabindex: _vm.disabled ? -1 : null,
                        id: _vm.elementId + "_label",
                        "aria-expanded": _vm.isOpen ? "true" : "false",
                        "aria-controls": _vm.elementId + "_content",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _vm._t("beforeLabel"),
                      _vm._v(" "),
                      _vm._t(
                        "label",
                        function () {
                          return [_vm._v(_vm._s(_vm.label))]
                        },
                        { label: _vm.label }
                      ),
                      _vm._v(" "),
                      _vm._t("afterLabel"),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: { name: "accordion" },
              on: {
                enter: function ($event) {
                  return _vm.onBeforeTransition($event, true)
                },
                "after-enter": function ($event) {
                  return _vm.onAfterTransition($event, true)
                },
                "before-leave": function ($event) {
                  return _vm.onBeforeTransition($event, false)
                },
                "after-leave": function ($event) {
                  return _vm.onAfterTransition($event, false)
                },
              },
            },
            [
              _c(
                "dd",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOpen,
                      expression: "isOpen",
                    },
                  ],
                  staticClass: "accordion__item",
                  class: {
                    // @deprecated accordion__item--active will be removed together with accordion__item--open
                    // you should use 'accordionItem--open' on the container instead!
                    "accordion__item--active": _vm.isOpen,
                    "accordion__item--open": _vm.isOpen,
                  },
                  attrs: {
                    id: _vm.elementId + "_content",
                    "aria-labelledby": _vm.elementId + "_label",
                  },
                },
                [
                  _vm._t("beforeContent"),
                  _vm._v(" "),
                  _vm._t("default"),
                  _vm._v(" "),
                  _vm._t("afterContent"),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }